import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  categoryName: '連携CMS',

  // 選択サービス名
  serviceName: null,
  
  // model
  serviceModel: [],
  cmsModel: [],
  linkedCmsMstModel: [],

  // form
  targetId: Constants.RegisterHash,
  values: {}
}

const getters = {
  get: state => state,
  
  // 登録値を表示用に変換
  getValue: state => (key) => {
    try {
      let value = state.values[key]
      switch (key) {
        default:
          return value
      }
    /* eslint-disable no-new */
    } catch (e) {
      return ''
    }
  }
}

const actions = {
  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {serviceLinkedCmsParams, linkedCmsMstParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        [
          'serviceLinkedCms',
          'linkedCmsMst',
        ],
        [
          'v1ServiceLinkedCmsListGet',
          'v1LinkedCmsMstListGet',
        ],
        [
          serviceLinkedCmsParams,
          linkedCmsMstParams,
        ])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('inited')
            commit('setServiceName', res[0].data.serviceName)
            commit('setCmsModel', res[0].data.serviceLinkedCmsSettings)
            commit('setLinkedCmsMstModel', res[1].data.linkedCmsMsts)
            console.log('cmsModel', state.cmsModel)
            console.log('linkedCmsMstModel', state.linkedCmsMstModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },

  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
  // init
  inited (state) {
    Vue.set(state.values, 'inpCmsId', '')
  },

  // service name
  setServiceName (state, str) {
    state.serviceName = str
  },

  // model
  setCmsModel (state, data) {
    Vue.set(state, 'cmsModel', data)
  },
  setLinkedCmsMstModel (state, data) {
    Vue.set(state, 'linkedCmsMstModel', data)
  },

  // form
  setTargetId (state, targetId) {
    state.targetId = targetId
  },
  setValues (state, values) {
    Vue.set(state, 'values', values)
  },
  setInputValue (state, {key, value}) {
    Vue.set(state.values, key, value)
  },

  // reset
  reset (state) {
    state.targetId = Constants.RegisterHash
    Vue.set(state, 'values', {})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
